var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "loginForm",
      staticClass: "demo-ruleForm login-container",
      attrs: {
        model: _vm.loginForm,
        rules: _vm.fieldRules,
        "label-position": "left",
        "label-width": "0px",
      },
    },
    [
      _c(
        "span",
        { staticClass: "tool-bar" },
        [
          _c("theme-picker", {
            staticClass: "theme-picker",
            staticStyle: { float: "right" },
            attrs: { default: _vm.themeColor },
            on: { onThemeChange: _vm.onThemeChange },
          }),
          _vm._v(" "),
          _c("lang-selector", { staticClass: "lang-selector" }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "h2",
        { staticClass: "title", staticStyle: { "padding-left": "22px" } },
        [_vm._v(_vm._s(_vm.appName))]
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "account" } },
        [
          _c("el-input", {
            attrs: {
              type: "text",
              "auto-complete": "off",
              placeholder: _vm.$t("user.account"),
            },
            model: {
              value: _vm.loginForm.account,
              callback: function ($$v) {
                _vm.$set(_vm.loginForm, "account", $$v)
              },
              expression: "loginForm.account",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "password" } },
        [
          _c("el-input", {
            attrs: {
              type: "password",
              "auto-complete": "off",
              placeholder: _vm.$t("user.password"),
            },
            model: {
              value: _vm.loginForm.password,
              callback: function ($$v) {
                _vm.$set(_vm.loginForm, "password", $$v)
              },
              expression: "loginForm.password",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { staticStyle: { width: "100%" } },
        [
          _c(
            "el-button",
            {
              staticStyle: { width: "48%" },
              attrs: { type: "primary" },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.reset($event)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common.reset")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { width: "48%" },
              attrs: { type: "primary", loading: _vm.loading },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.login($event)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common.login")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }